module.exports = __webpack_public_path__ + "img/xx.012bea55.png";